import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import Div from '../Div'
import './card.scss'
import { localizePath } from '../../helper/localizedPath';

export default function Card({title, link, src, alt}) {
  const { i18n } = useTranslation();

  return (
    <Link to={localizePath(link, i18n.language === 'en' ? 'en' : 'cs')} className="cs-card cs-style1">
      <>
        <img src={src} alt={alt} />
        <Div className="cs-card_overlay" />
        <Div className="cs-card_info">
          <span className=" cs-hover_layer3 cs-accent_bg" />
          <h2 className="cs-card_title">{title}</h2>
        </Div>
      </>
    </Link>
  )
}
